<template>
  <div :class="`row ${backgroundClass} ${heightClass}`">
    <div class="w-100 col-12 px-0">
      <div
        class="text-sm border-right left-display"
        :class="[{'expanded-left-display': showPanel}, reverseBgColors ? 'bg-gray-50' : 'bg-white']"
      >
        <slot name="left-content-header">   
        </slot>
        <div class="p-3">
          <slot name="left-content">
            Left Content Goes Here
          </slot>
        </div>
      </div>

      <div class="assets-panel" :class="[{'expand-assets':!showPanel}, !rcNoPadding && !showPanel ? 'pl-3' : '', reverseBgColors ? 'bg-white' : 'bg-gray-50']">
        <button :style="`left: ${!showPanel ? '20px': ''}`" @click="showPanel = !showPanel" type="button" class="btn btn-white btn-sm rounded-circle border left-display-toggle" style="width: 30px; height: 30px; z-index: 1;">
            <i class="fa fa-angle-left" v-if="showPanel"></i>
            <i class="fa fa-angle-right" v-else></i>
        </button>
        <perfect-scrollbar :class="['content-list', rcNoPadding ? '' : 'px-4 py-3']">
          <slot name="right-content">
            Panel Right Content Goes Here
          </slot>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    backgroundClass: {
      type: String,
      default: "bg-white"
    },
    heightClass: {
      type: String,
      default: ''
    },
    showPanel: {
      type: Boolean,
      default: true
    },
    rcNoPadding: {
      type: Boolean,
      default: false
    },
    reverseBgColors: {
      type: Boolean,
      default: false
    }
  },
};
</script>

<style lang="scss" scoped>
$left-panel-width: 300px;
$transition: 200ms ease all;

.content-list {
  height: calc(100vh - 105px);
}

.left-display{
  vertical-align: top;
  width: 0px;
  display: inline-block;
  position: absolute;
  min-height: 100%;
  width: $left-panel-width;

  &.expanded-left-display {
    width: $left-panel-width;
    overflow: visible;
  }
}

.assets-panel {
  position: relative;
  margin-left: $left-panel-width;
  transition: $transition;
  height: 100%;
  &.expand-assets {
    margin-left: 0px;
  }
  .left-display-toggle{
    background-color: #fbfbfb;
    position: absolute;
    transition: $transition;
    left: 0px;
    transform: translateX(-50%);
    top: 20px;
  }
}

.assets-panel.expand-assets::before{
  content: "";
  position: absolute;
  height: 100%;
  width: 1px;
  background: #e5ecf4;
  top: 0;
  left: 1rem;
}
</style>